import Vue from 'vue'
import Router from 'vue-router'
import Design from '@/views/Design'
import Search from '@/views/Search'
import AboutUs from '@/views/AboutUs'
import Details from '@/views/Details3'
import LawArticle from '@/views/LawArticle'
import Returns from '@/views/Returns'
import PhotoGraph from '@/views/PhotoGraph'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Design',
      component: Design,
      meta: {
        title: 'Design | Oasisdream'
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        title: 'Search | Oasisdream'
      }
    },
    {
      path: '/about',
      name: 'AboutUs',
      component: AboutUs,
      meta: {
        title: 'About | Oasisdream'
      }
    },
    {
      path: '/designs/:id',
      name: 'designs',
      component: Details,
      meta: {
        title: 'Designs | Oasisdream'
      }
    },
    {
      path: '/legal',
      name: 'legal',
      component: LawArticle,
      meta: {
        title: 'Legal | Oasisdream'
      }
    },
    {
      path: '/returns',
      name: 'Returns',
      component: Returns,
      meta: {
        title: 'Returns | Oasisdream'
      }
    },
    {
      path: '/photograph',
      name: 'PhotoGraph',
      component: PhotoGraph,
      meta: {
        title: 'PhotoGraph | Oasisdream'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js